module.exports = __webpack_public_path__ + "static/media/caserma-zucchi-unimore-dossetti.3f724e10.svg";